export function Lightning() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1545_9697)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.01493 0.378732C4.07058 0.156149 4.27057 0 4.5 0H9.5C9.65397 0 9.79935 0.0709358 9.89411 0.192294C9.98886 0.313652 10.0224 0.471897 9.98508 0.621268L9.14039 4H13.5C13.6825 4 13.8505 4.09942 13.9383 4.2594C14.0261 4.41937 14.0198 4.61448 13.9218 4.76844L6.92184 15.7684C6.79539 15.9671 6.54742 16.0507 6.32653 15.9689C6.10564 15.8872 5.97172 15.6624 6.00503 15.4293L6.9235 9H2.5C2.34604 9 2.20066 8.92906 2.1059 8.80771C2.01115 8.68635 1.97759 8.5281 2.01493 8.37873L4.01493 0.378732ZM4.89039 1L3.14039 8H7.5C7.64495 8 7.78276 8.0629 7.87773 8.1724C7.9727 8.2819 8.01548 8.42722 7.99498 8.57071L7.32284 13.2757L12.5892 5H8.5C8.34604 5 8.20066 4.92906 8.1059 4.80771C8.01115 4.68635 7.97759 4.5281 8.01493 4.37873L8.85962 1H4.89039Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1545_9697">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
